<template>
  <div class="set-password">
    <headerBack></headerBack>
    <div class="title">设置登录密码</div>
    <div class="content">
      <p>为您的账号设置一个新密码</p>
      <p>{{userInfo.phone}}</p>
      <div class="item password">
        <div class="input-box">
          <label>新密码</label>
          <input
            v-model="password"
            :type="passwordType"
            placeholder="6-16位数字、字母"
            minlength="6"
            maxlength="16"
          >
        </div>
        <span
          class="eye-btn iconfont iconkejian"
          @click="openEye"
          :class="passwordType == 'password' ? '':'active'"
        ></span>
      </div>
      <div class="btn-box">
        <loading-btn btnClass="btn" v-preventReClick @click="handleNext">保存</loading-btn>
      </div>
    </div>
  </div>
</template>

<script>
import headerBack from "@/components/common/headerBack.vue";
import loadingBtn from "@/components/common/loadingBtn";
import userApi from "@/api/userApi";
import validationMixin from "@/mixins/validationMixin";
import { AESEncrypted } from "@/libs/util";

export default {
  data() {
    return {
      userInfo: this.$store.state.userInfo,
      password: "",
      passwordType: "password" // 密码状态切换
    };
  },
  mixins: [validationMixin],
  mounted() {},
  components: {
    headerBack,
    loadingBtn
  },
  methods: {
    openEye() {
      if (this.passwordType === "text") {
        this.passwordType = "password";
      } else {
        this.passwordType = "text";
      }
    },
    handleNext() {
      let validations = [
        {
          value: this.password,
          method: "required",
          message: "请输入密码（6-16位数字、字母）"
        },
        {
          value: this.password,
          method: "rangelength",
          param: [6, 16],
          message: "密码长度错误（6-16位数字、字母）"
        }
      ];

      if (this.check(validations)) {
        if (!/^[a-z0-9]{6,16}$/.test(this.password)) {
          this.$toast("密码格式错误（6-16位数字、字母）");
          return;
        }
        // 将密码明文进行AES加密
        const ciphertext = AESEncrypted(this.password)
        const params = {
          password: ciphertext,	
          user_id: this.userInfo.user_id
        }
        userApi.setLoginPasswordFirst(params).then(res => {
          console.log(res)
          this.$router.push({
            name: "myUserHome"
          });
        })
      }
    }
  }
};
</script>

<style lang="less" scoped>
.set-password {
  padding: 34.133vw 8vw 0 8vw;

  .title {
    font-size: 30px;
    color: #333333;
  }
  .content {
    margin-top: 20px;
    width: 100%;

    p {
      font-size: 14px;
      line-height: 1.8;
      color: #333333;
    }

    .item {
      height: 60px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e4e4e4;
      font-size: 14px;
      margin-top: 40px;

      label {
        width: 45px;
        display: inline-block;
        font-size: 14px;
        color: #333333;
        margin-right: 23px;
      }

      .eye-btn {
        font-size: 12px;
        color: #999999;
        display: block;
        padding: 10px;

        &.active {
          color: #8a3e2f;
        }
      }
    }

    .btn-box {
      margin-top: 97px;
      .btn {
        width: 100%;
        height: 44px;
        text-align: center;
        line-height: 44px;
        background: #8a3e2f;
        font-size: 17px;
        color: #ffffff;

        &.nostyle {
          background: none;
          color: #333333;
        }
      }
    }
  }
}
</style>
